import { Point } from './BasicTypes'

/**
 * Wander CRS is a Coordinate Reference System which mapping WGS84 lat/long
 * coordinates from 180 °W to 180 °E, 85.0511 °N to 85.0511 °S with mercator
 * projection (from EPSG:4326 to EPSG:3857) to a (2 ^ level) * (2 ^ level) size.
 * square.
 *
 * It's pretty much identical to the pixel CRS Leaftlet or other web map system
 * used. We made it like this so that it's super easy to transform from
 * Wander CRS to Leaftlet CRS (EPSG3857), only scaling transforming is needed.
 *
 * We pick level 10 as the default standard CRS scale. By doing so, we will get
 * a 1024 * 1024 square. You can think of it's mapping EPSG3857 world map in
 * 180 °W to 180 °E, 85.0511 °N to 85.0511 °S boundary to a 1024 * 1024 size
 * box.
 *
 * Please reference to http://wiki.openstreetmap.org/wiki/Slippy_map_tilenames
 */
export default class WanderCRS {
  /**
   * power level of map boundary, for example, if given level is 10, then
   * wnader CRS map size is 2 ^ 10, which will be 1024 * 1024
   */
  readonly level: number

  /**
   * size of wander map in wander CRS unit
   */
  get wanderMapSize () {
    return Math.pow(2, this.level)
  }

  constructor (level: number = 10) {
    this.level = level
  }

  /**
   * Convert given wander world CRS point to map pixel point
   * @param point point in wander world CRS
   * @param zoomLevel zoom level in map to convert to
   * @param tileSize tileSize for map
   * @returns point in map pixel CRS
   */
  wanderToPixel (point: Point, zoomLevel: number, tileSize: number = 256): Point {
    const wanderMapSize = this.wanderMapSize
    const mapSize = Math.pow(2, zoomLevel)
    const scalar = (mapSize / wanderMapSize) * tileSize
    return {
      x: point.x * scalar,
      y: point.y * scalar
    }
  }

  /**
   * Convert given map pixel point to wander world CRS point
   * @param point  point in map pixel CRS
   * @param zoomLevel zoom level in map to convert to
   * @param tileSize tileSize for map
   */
  pixelToWander (point: Point, zoomLevel: number, tileSize: number = 256): Point {
    const wanderMapSize = this.wanderMapSize
    const mapSize = Math.pow(2, zoomLevel)
    const scalar = (mapSize / wanderMapSize) * tileSize
    return {
      x: point.x / scalar,
      y: point.y / scalar
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/WanderCRS.ts